import { Box, Button } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Typography from '@mui/material/Typography';

interface ProjectErrorBoundaryProps {
  error: unknown;
  componentStack: string;
  resetError: () => void;
}

export const ProjectErrorBoundary = (props: ProjectErrorBoundaryProps) => {
  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '200px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <WarningAmberIcon color="warning" fontSize="large" sx={{ mb: 0.25 }} />
      <Typography variant="body1">An error has occured</Typography>
      <Button
        sx={{ mt: 2 }}
        size={'small'}
        onClick={() => {
          props.resetError();
        }}
        variant={'contained'}
      >
        Click here to reset
      </Button>
    </Box>
  );
};
